export function isMatriz(cnpj) {
  return cnpj?.slice(8, 12) === '0001';
}
